import { analyticsActionTypes } from '@Actions/application/analyticsActions';

const AnalyticsReducers = (state = {
  analytics: {
    PURCHASE: {
      TOTAL_SPEND: {
        params: null,
        data: null,
        loading: false,
      },
      PURCHASE_BY_STATUS: {
        params: null,
        data: null,
        loading: false,
      },
      PURCHASE_BY_APPROVAL_STATUS: {
        params: null,
        data: null,
        loading: false,
      },
      PURCHASE_SCHEDULE: {
        params: null,
        data: null,
        loading: false,
      },
      OVERDUE_GRN: {
        params: null,
        data: null,
        loading: false,
      },
      PR_BY_DEPARTMENT: {
        params: null,
        data: null,
        loading: false,
      },
    },
    SALES: {
      AVERAGE_ORDER_VALUE: {
        params: null,
        data: null,
        loading: false,
      },
      ORDER_STATISTICS: {
        params: null,
        data: null,
        loading: false,
      },
      ON_TIME_DELIVERY: {
        params: null,
        data: null,
        loading: false,
      },
      ORDER_COUNT_BY_STATUS: {
        params: null,
        data: null,
        loading: false,
      },
      ORDER_TREND: {
        params: null,
        data: null,
        loading: false,
      },
      ORDER_VALUE_BY_TYPE: {
        params: null,
        data: null,
        loading: false,
      },
      ORDER_VALUE_BY_CATEGORY: {
        params: null,
        data: null,
        loading: false,
      },
      ORDER_VALUE_BY_STATE: {
        params: null,
        data: null,
        loading: false,
      },
      ORDER_STATS_BY_CUSTOMER: {
        params: null,
        data: null,
        loading: false,
      },
      ORDER_STATS_BY_PRODUCT: {
        params: null,
        data: null,
        loading: false,
      },
      ORDER_STATS_BY_SOURCE: {
        params: null,
        data: null,
        loading: false,
      },
      ORDER_STATS_BY_SALES_PERSON: {
        params: null,
        data: null,
        loading: false,
      },
      SALES_GROWTH_CUSTOMER_WISE: {
        params: null,
        data: null,
        loading: false,
      },
      ORDER_RECEIVABLES: {
        params: null,
        data: null,
        loading: false,
      },
    },
    PRODUCTION: {
      PRODUCTION_VALUE: {
        params: null,
        data: null,
        loading: false,
      },
      PRODUCTION_BY_STATUS: {
        params: null,
        data: null,
        loading: false,
      },
      PRODUCTION_BY_MACHINE_STATUS: {
        params: null,
        data: null,
        loading: false,
      },
      OVERDUE_SCHEDULE_MO: {
        params: null,
        data: null,
        loading: false,
      },
      RESOURCE_WORKLOAD: {
        params: null,
        data: null,
        loading: false,
      },
      ASSIGNEES_WORKLOAD: {
        params: null,
        data: null,
        loading: false,
      },
      PRODUCTION_OUTPUT: {
        params: null,
        data: null,
        loading: false,
      },
      PRODUCTION_DELIVERY_TIMELINESS: {
        params: null,
        data: null,
        loading: false,
      },
      PRODUCTION_TREND: {
        params: null,
        data: null,
        loading: false,
      },
      PRODUCTION_PRODUCT_WISE: {
        params: null,
        data: null,
        loading: false,
      },
    },
    INVENTORY: {},
    INVENTORY_STOCK_STATUS_SPLIT: {
      params: null,
      data: null,
      loading: false,
    },
    INVENTORY_STOCK_VALUATION: {
      params: null,
      data: null,
      loading: false,
    },
    INVENTORY_OPEN_TRANSFERS: {
      params: null,
      data: null,
      loading: false,
    },
    INVENTORY_AGEING_SPLIT: {
      params: null,
      data: null,
      loading: false,
    },
  },
  downloadQueue: {},
}, action) => {
  switch (action.type) {
    case analyticsActionTypes.GET_ANALYTICS_DATA.REQUEST: {
      const { dataType, name, params } = action;
      if (dataType === 'INVENTORY') {
        return {
          ...state,
          [`${dataType}_${name}`]: {
            ...state?.[`${dataType}_${name}`],
            params,
          },
        };
      }
      const analytics = JSON.parse(JSON.stringify(state.analytics));
      analytics[dataType][name].params = params;
      return {
        ...state,
        analytics,
      };
    }
    case analyticsActionTypes.GET_ANALYTICS_DATA.LOADING: {
      const { dataType, name, loading } = action;
      if (dataType === 'INVENTORY') {
        return {
          ...state,
          [`${dataType}_${name}`]: {
            ...state?.[`${dataType}_${name}`],
            loading,
          },
        };
      }
      const analytics = JSON.parse(JSON.stringify(state.analytics));
      analytics[dataType][name].loading = loading;
      return {
        ...state,
        analytics,
      };
    }
    case analyticsActionTypes.GET_ANALYTICS_DATA.SUCCESS: {
      const { dataType, name, data } = action;
      if (dataType === 'INVENTORY') {
        return {
          ...state,
          [`${dataType}_${name}`]: {
            ...state?.[`${dataType}_${name}`],
            data,
          },
        };
      }
      const analytics = JSON.parse(JSON.stringify(state.analytics));
      analytics[dataType][name].data = data;
      return {
        ...state,
        analytics,
      };
    }
    case analyticsActionTypes.DOWNLOAD_DOCUMENT.LOADING: {
      const { payload } = action;
      const downloadQueue = JSON.parse(JSON.stringify(state?.downloadQueue));
      downloadQueue[payload?.key] = {
        ...payload,
        loading: true,
      };
      return {
        ...state,
        downloadQueue,
      };
    }
    case analyticsActionTypes.DOWNLOAD_DOCUMENT.SUCCESS: {
      const { key } = action;
      const downloadQueue = JSON.parse(JSON.stringify(state?.downloadQueue));
      delete downloadQueue[key];
      return {
        ...state,
        downloadQueue,
      };
    }

    // label download
    case analyticsActionTypes.PRINT_LABELS.LOADING: {
      const { printLabelsLoading } = action;
      return {
        ...state,
        printLabelsLoading,
      };
    }
    case analyticsActionTypes.PRINT_LABELS.SUCCESS: {
      const { printedLabels } = action;
      return {
        ...state,
        printedLabels,
      };
    }


    case analyticsActionTypes.GET_BULK_UPLOADS.LOADING: {
      const { getBulkUploadsLoading } = action;
      return {
        ...state,
        getBulkUploadsLoading,
      };
    }
    case analyticsActionTypes.COMMON_GET_REQUEST.LOADING: {
      const { commonGetRequestsLoading } = action;
      return {
        ...state,
        commonGetRequestsLoading,
      };
    }
    case analyticsActionTypes.GET_BULK_UPLOADS.SUCCESS: {
      const { bulkUploads } = action;
      return {
        ...state,
        bulkUploads,
      };
    }
    default: {
      return state;
    }
  }
};

export default AnalyticsReducers;
